module.exports = __webpack_public_path__ + "img/9791155311127.70c8bab3.jpg";